import { FaBuilding, FaBuildingUser } from "react-icons/fa6";
import { BsFillBuildingsFill } from "react-icons/bs";

export const linksLawyer = [
    { label: "Clientes Defensa Fiscal", path: "/clientes_df", icon: BsFillBuildingsFill },
    { label: "Clientes", path: "/clientes", icon: FaBuildingUser },
    { label: "Empresas", path: "/empresa", icon: FaBuilding },
];